import { Component, AfterViewInit, OnInit, OnDestroy, NgZone, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
} from '@covalent/core';

import { JuicioDiagnostico } from '../../../../models';

import { JuicioDiagnosticoService, LoginService, } from '../../../../services/';

@Component({
  selector: 'qs-juiciodiagnostico',
  templateUrl: './juiciodiagnostico.component.html',
  styleUrls: ['./juiciodiagnostico.component.scss'],
  viewProviders: [JuicioDiagnosticoService],
})
export class JuicioDiagnosticoComponent implements AfterViewInit, OnInit, OnDestroy {

  private idPaciente: string;
  private juiciodiagnostico: JuicioDiagnostico[];

  private _xsScreen: Subscription;

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'cip', label: 'CIP', hidden: true },
    { name: 'fecha', label: 'Fecha', tooltip: 'Fecha', sortable: true },
    { name: 'hora', label: 'Hora', tooltip: 'Hora', sortable: false },
    { name: 'descripcion', label: 'Descripción', tooltip: 'Descripción', sortable: false },
    { name: 'visita', label: 'Visita', hidden: true },
    { name: 'exObservaciones', label: 'Observaciones', hidden: true },
    { name: 'codigo', label: 'Código', hidden: true },
    { name: 'textoHTMLClob', label: 'Texto', hidden: true },
    { name: 'numeroExpediente', label: 'Núm. Exp.', hidden: true },
    { name: 'dniMedico', label: 'DNI', hidden: true },
    { name: 'idExplotex', label: 'Id Explotex', hidden: true },
    { name: 'dniBorrado', label: 'DNI Borrado', hidden: true },
    { name: 'motivoBorrado', label: 'M.B.', hidden: true },
    { name: 'accion', label: 'Acción', hidden: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: JuicioDiagnostico[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  @ViewChild(TdDataTableComponent) tableComponent: TdDataTableComponent;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _juicioDiagnosticoService: JuicioDiagnosticoService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.watchScreen();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('juiciodiagnostico.load');
    this._juicioDiagnosticoService.obtenerJuicioDiagnostico(this._loginService.consulta.numeroExpediente, this._loginService.consulta.visita)
    .subscribe((res: any) => {
      this.juiciodiagnostico = res.respuesta.diagnosticos || '';
      this.filteredData = this.juiciodiagnostico;
      this.filteredDataTotal = this.juiciodiagnostico.length;
      this._loadingService.resolve('juiciodiagnostico.load');
    }, (error: Error) => {
      this._loadingService.resolve('juiciodiagnostico.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.watchScreen();
  }

  /**
   * watchScreen:
   * Observable de cambio de resolució. Oculta o muestra columnas
   * xs < 600px
   * sm > 600px
   * md < 1280px
   */
  watchScreen(): void {
    this._xsScreen = this.media.registerQuery('xs').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          // Ocultamos columnas
          this.columns[0].hidden = true;
          // this.tableComponent.refresh();
        } else {
          // Mostramos columnas
          this.columns[0].hidden = false;
          // this.tableComponent.refresh();
        }
      });
    });
  }

  openDetalleAlta(): void {
    this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/hojadeseguimiento',
    { outlets: { hojadeseguimiento: ['juiciodetalle'] } }]);
  }

  /**
   * openDetalle: Muestra la vista de detalle pasando la linea seccionada
   * @param any: $event <- Fila seleccionada
   */
  openDetalle(juicioDiagnostico: any): void {
    if (juicioDiagnostico) {
      this._loginService.transient = juicioDiagnostico;
      this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/hojadeseguimiento',
      { outlets: { hojadeseguimiento: ['juiciodetalle'] } }]);
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.juiciodiagnostico;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  ngOnDestroy(): void {
    this._xsScreen.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/hojadeseguimiento/juiciodiagnostico/juiciodiagnostico.component.ts